<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="structure">
<div class="epigraph">
<p class="epf"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>The opponents of nationalism see us as uncompromising nationalists, with a nationalist God and a nationalist Torah; the nationalists see us as cosmopolitans, whose homeland is wherever we happen to be well off. Religious gentiles say that we are devoid of any faith, and the freethinkers among them say that we are orthodox and believe in all kinds of nonsense; the liberals say we are conservative and the conservatives call us liberal. Some bureaucrats and writers see us as the root of anarchy, insurrection, and revolt, and the anarchists say we are capitalists, the bearers of the biblical civilization, which is, in their view, based on slavery and parasitism. . . . Even our merits are turned into shortcomings.</p>
<p class="ept"><span class="sm">MOSHE</span> <span class="sm">LEIB</span> <span class="sm">LILIENBLUM,</span> <i>The Future of Our People</i>, 1883</p>
<p class="epf">De te fabula narratur!</p>
<p class="ept"><span class="sm">KARL</span> <span class="sm">MARX,</span> quoting Horace, in the preface to the first German edition of <i>Capital</i>, 1867</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Goldberg-0006.vue?44b2d8cc